import React from 'react';
import JdForm from './JdForm';
import { Container } from '@/components/ui/container';
import { Heading } from '@/components/ui/typography';
import { cn } from '@/lib/utils';

function MainContent() {
  return (
    <main className={cn("min-h-screen bg-background py-8")}>
      <Container>
        <Heading level="h1" className="text-3xl font-bold mb-8 text-center">JD Creation</Heading>
        <JdForm />
      </Container>
    </main>
  );
}

export default MainContent;